/**
 * Number formatting utilities shared across all pages.
 * Change locale or fraction digits here to update everywhere.
 */

const LOCALE = 'en-IN';
const CURRENCY = '\u20B9';

/**
 * Format a number as Indian-locale currency string.
 * e.g. 123456.789 -> "1,23,456.79"
 */
export const fmt = (n) =>
  Number(n || 0).toLocaleString(LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

/**
 * Format with currency prefix. e.g. 500 -> INR symbol + "500.00"
 */
export const fmtCurrency = (n) => `${CURRENCY}${fmt(n)}`;

/**
 * Format gold grams. e.g. 2.5 -> "2.500 g"
 */
export const fmtGrams = (n) =>
  Number(n || 0).toLocaleString(LOCALE, {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3,
  }) + ' g';

/**
 * Compact large numbers. e.g. 1500000 -> "15.0 L"
 */
export const fmtCompact = (n) => {
  const val = Number(n || 0);
  if (val >= 1_00_00_000) return `${(val / 1_00_00_000).toFixed(1)} Cr`;
  if (val >= 1_00_000)    return `${(val / 1_00_000).toFixed(1)} L`;
  if (val >= 1_000)       return `${(val / 1_000).toFixed(1)} K`;
  return String(val);
};


